// LEAGUES

export const leagueFetch = () => ({
    type: LEAGUE_PENDING,
});
export const leagueSuccess = (data) => ({
    type: LEAGUE_SUCCESS,
    payload: data,
});
export const leagueError = (error) => ({
    type: LEAGUE_ERROR,
    payload: error,
});
export const matchDelete = (matchDayId, matchId) => ({
    type: MATCH_DELETE,
    payload: { matchDayId, matchId },
});
export const matchAdd = (matchDayId, matchId) => ({
    type: MATCH_ADD,
    payload: { matchDayId, matchId },
});
export const switchChange = (isOfficial) => ({
    type: SWITCH_CHANGE,
    payload: isOfficial,
});
export const matchDayAdd = (newMatchDay) => ({
    type: NEW_MATCH_DAY,
    payload: newMatchDay,
});
export const matchDayFormShow = (showForm) => ({
    type: MATCH_DAY_FORM,
    payload: showForm,
});

// MATCHES

export const matchesFetch = () => ({
    type: MATCHES_PENDING,
});
export const matchesSuccess = (data) => ({
    type: MATCHES_SUCCESS,
    payload: data,
});
export const matchesError = (error) => ({
    type: MATCHES_ERROR,
    payload: error,
});
export const matchSubmitSuccess = (match) => ({
    type: MATCH_SUBMIT,
    payload: match,
});

// TEAMS

export const teamsFetch = () => ({
    type: TEAMS_PENDING,
});
export const teamsSuccess = (data) => ({
    type: TEAMS_SUCCESS,
    payload: data,
});
export const teamsError = (error) => ({
    type: TEAMS_ERROR,
    payload: error,
});

// STATUS

export const statusesFetch = () => ({
    type: STATUSES_PENDING,
});
export const statusesSuccess = (data) => ({
    type: STATUSES_SUCCESS,
    payload: data,
});
export const statusesError = (error) => ({
    type: STATUSES_ERROR,
    payload: error,
});

// Types

const LEAGUE_PENDING = "LEAGUE_PENDING";
const LEAGUE_SUCCESS = "LEAGUE_SUCCESS";
const LEAGUE_ERROR = "LEAGUE_ERROR";
const MATCH_DELETE = "MATCH_DELETE";
const MATCH_ADD = "MATCH_ADD";
const SWITCH_CHANGE = "SWITCH_CHANGE";
const NEW_MATCH_DAY = "NEW_MATCH_DAY";
const MATCH_DAY_FORM = "MATCH_DAY_FORM";

const MATCHES_PENDING = "MATCHES_PENDING";
const MATCHES_SUCCESS = "MATCHES_SUCCESS";
const MATCHES_ERROR = "MATCHES_ERROR";
const MATCH_SUBMIT = "MATCH_SUBMIT";

const TEAMS_PENDING = "TEAMS_PENDING";
const TEAMS_SUCCESS = "TEAMS_SUCCESS";
const TEAMS_ERROR = "TEAMS_ERROR";

const STATUSES_PENDING = "STATUSES_PENDING";
const STATUSES_SUCCESS = "STATUSES_SUCCESS";
const STATUSES_ERROR = "STATUSES_ERROR";
